export default __webpack_public_path__ + "static/media/taxBg@2x.ce665631.png";